import * as React from "react";
import styled from "styled-components";
import { Section } from "@origin-digital/ods-core";
import { BREAK_POINTS, COLOURS, TEXT } from "../../consts/style";

import { SocialLinks } from "../SocialLinks/SocialLinks";
import { IFooter } from "../../content/interfaces";
import { Link, LinkProps } from "../Link";
import { GoodEnergySmall } from "../GoodEnergy";

export const createTrackingCode = (type: string, id: string) => `${type}-${id}`;

const FooterNavContainer = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  @media (min-width: ${BREAK_POINTS.MAX.XS}) {
    flex-direction: row;
  }
`;

const FooterNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
`;

const FooterNavLink = styled(Link)<LinkProps>`
  text-decoration: none;
  margin-right: 48px;
  font-size: 12px;
  color: ${TEXT.BODY};
  line-height: 1.67;
  font-weight: normal;
  text-align: left;
  @media (max-width: ${BREAK_POINTS.MAX.SM}) {
    margin-right: 24px;
    margin-bottom: 8px;
  }
  &:hover {
    color: ${TEXT.LINK.HOVER};
  }
`;

const Copyright = styled.div`
  display: flex;
  font-size: 12px;
  line-height: 1.67;
  text-align: left;
  font-weight: normal;
  color: ${COLOURS.GREY.GREY_80};
  padding-top: 16px;
  @media (min-width: ${BREAK_POINTS.MAX.XS}) {
    padding-top: 0;
  }
`;

const Divider = styled.div`
  border-top: solid 1px #e3e3e3;
  height: 1px;
  margin-top: 24px;
  margin-bottom: 24px;
  @media (min-width: ${BREAK_POINTS.MAX.SM}) {
    margin-bottom: 40px;
  }
`;

const TopFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0;
  @media (max-width: ${BREAK_POINTS.MAX.XS}) {
    display: none;
  }
`;

export const LegacyFooter = ({ links, socialLinks }: IFooter) => (
  <Section data-comment="Footer" data-id="footer">
    <TopFooterContainer>
      <GoodEnergySmall />
      <SocialContainer>
        <SocialLinks socialLinks={socialLinks} />
      </SocialContainer>
    </TopFooterContainer>
    <Divider />
    <FooterNavContainer>
      <FooterNav>
        {links.map(({ headline, buttonUrl }, ix) => (
          <FooterNavLink
            key={ix}
            href={buttonUrl}
            data-id={createTrackingCode("footerLink", headline)}
            trackingType="footerLink"
          >
            {headline}
          </FooterNavLink>
        ))}
      </FooterNav>
      <Copyright>
        &copy; {new Date().getFullYear()} Origin Energy Limited
      </Copyright>
    </FooterNavContainer>
  </Section>
);
